import TextareaAutosize from 'react-textarea-autosize';
import styled from 'styled-components';

export const StyledCheckInTextInput = styled(TextareaAutosize)`
  font-size: 14px;
  border: none;
  flex: 1;
`;
